import React, {useEffect, useState} from "react"
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import MaterialSpinner from "../../ui/materialSpinner";
import {getImagePromiseFromLayout} from "../../../misc/getCanvasImageFromLayout";
import {createFakeLayout, getCurrentLayout} from "../../appLayout";
import {useIsMounted} from "../../../misc/helperHooks";
import {setLookOverlayOpened, setLookViewChangeOptions} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {baseNewImagesPath} from "../../assets";
// import Config from "../../../config";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";

const LookLayoutItem = (props) => {

  const {look, imageOnly, setLookOverlayOpened, setLookViewChangeOptions, popupCloseClick} = props;
  const isMounted = useIsMounted();

  const layout = getCurrentLayout();
  const type = layout.layoutTypes[look.lookLayout];
  const [thumbnailUrl, setThumbnailUrl] = useState(
    layout.layoutThumbnails && layout.layoutThumbnails[look.lookLayout] ? layout.layoutThumbnails[look.lookLayout] : ""
  );
  const isActive = type === layout.type && layout.scene === look.lookScene;

  const handleLayoutItemClick = () => {
    const analyticsQuery = `layout_type=${type}-scene=${look.lookScene}`;
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookRoom + analyticsQuery);
    if (!isActive) {
      setLookOverlayOpened(LOOK_OVERLAYS.questionView);
      setLookViewChangeOptions({
        newLayoutType: type,
        newScene: look.lookScene,
        itemsToRemove: [], //todo
      })
    } else {
      popupCloseClick();
    }
  }

  useEffect(() => {
    if (!thumbnailUrl) {
      const getLayoutThumbnail = async () => {
        const fakeLayout = isActive ? layout : createFakeLayout(layout, look.lookLayout, look.lookScene);
        if (!isActive) {
          const currentState = layout.getActiveFeaturesAsObject(true, false, true); // get current selected features
          await fakeLayout.selectLayout(type, layout.type, currentState, look.lookScene, null, true);
        }
        getImagePromiseFromLayout(fakeLayout)
          .then(response => {
            // console.log("response", response);
            if (isMounted()) {
              setThumbnailUrl(response);
            }
          })

      }
      getLayoutThumbnail(isMounted);
    } else if (!thumbnailUrl) {
      setThumbnailUrl(`${baseNewImagesPath}images/image-not-found.png`);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (imageOnly) {
    return <img src={thumbnailUrl} className="layout-image" alt="item.type"/>
  }

  return (
    <li className="ll-layout-wrapper" onClick={() => handleLayoutItemClick(look)}>
      <div className={"ll-layout" + (isActive ? " ll-layout--active" : "")}>
        <div className={"ll-layout__thumbnail" + (!thumbnailUrl ? " ll-layout__thumbnail--loading" : "")}>
          {thumbnailUrl ? <img src={thumbnailUrl} className="ll-layout__thumbnail-image" alt="item.type"/> : <MaterialSpinner/>}
        </div>
        <div className="ll-layout__content">
          {/*<div className="ll-layout__content-title">*/}
          {/*  <span className="ll-layout__content-title-name">{look.lookLayout}</span>*/}
          {/*  <span className="ll-layout__content-title-sqm">24 sqm</span>*/}
          {/*</div>*/}
          <div className="ll-layout__content-description">
            <span className="ll-layout__content-description-text">
              <FormattedMessage id="look.layout.item.layout"/> {look.lookLayout}
            </span>
            <span className="ll-layout__content-description-text">
              <FormattedMessage id="look.layout.item.scene"/> {look.lookScene}
            </span>
          </div>
        </div>
      </div>
    </li>
  );
}

LookLayoutItem.propTypes = {
  look: PropTypes.object.isRequired,
  popupCloseClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  imageOnly: PropTypes.bool,
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookViewChangeOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookLayoutItem)
